import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import SetupData from '../../data/SetupData';

// export interface AgentState {
//   _id: string | null
//   userName: string
//   name: string
//   email: string
//   image: string
//   views: string
//   expiryDate: Date | null
//   state: string
//   area: string
//   loc: any | null
// }

const initialState = {
  _id: null,
  userName: '',
  name: '',
  email: '',
  image: '',
  views: '',
  companyName: '',
  expiryDate: null,
  state: '',
  area: '',
  loc: null,
  active: '',
  newTnc: null,
  TOOS: false,
  packageInfo: { _id: null },
  postingAccess: false,
  propStoryAccess: false,
  bdInfo: {},
  reminder: {},
  bestdeal: {},
}

export const agentSlice = createSlice({
  name: 'agent',
  initialState,
  reducers: {
    updateAgentSlice: (state, action) => {
      return {
        ...action.payload,
      };
    }
  },
})

export const { updateAgentSlice, logOut } = agentSlice.actions

export const bestDealInfo = state => state.agent.bestdeal;

export const eligibleForBestDeal = state => {
  const eligibleTags = SetupData.packageTags.bestDeal;
  if (eligibleTags.includes(state.agent.packageInfo.tag)) return true;
  else return false;
}

export default agentSlice.reducer
